var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import MinimizeIcon from '../icons/minimize-icon';
import CloseIcon from '../icons/close-icon';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useTSState } from '../../TSContext';
import api from '../../api/actions';
import BodyWidget from './body-widget';
import classNames from 'classnames';
import MaxIcon from '../icons/max-icon';
import SpeedButton from './speed-button';
import Draggable from 'react-draggable';
const TSPlayer = () => {
    const { state, setStateLocal } = useTSState();
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const onClose = () => {
        setStateLocal({ currentScreen: 'bubble' });
    };
    const audioRef = useRef(null);
    useEffect(() => {
        const perfomAction = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (state.voiceId) {
                setStateLocal({
                    urlAudio: '',
                    isTranslating: true,
                    isGettingAudio: true
                });
                const audioResponse = yield api.translateSynthesize({
                    text: state.selectedText,
                    voiceId: state.voiceId,
                    s3SignedUrl: true,
                    sourceLanguage: 'en',
                    targetLanguage: state.languageCode
                });
                if ((_a = audioResponse === null || audioResponse === void 0 ? void 0 : audioResponse.synthesizeResponse) === null || _a === void 0 ? void 0 : _a.s3SignedUrl) {
                    setStateLocal({
                        urlAudio: audioResponse.synthesizeResponse.s3SignedUrl,
                        isGettingAudio: false,
                        isTranslating: false,
                        translatedText: (_b = audioResponse === null || audioResponse === void 0 ? void 0 : audioResponse.translateResponse) === null || _b === void 0 ? void 0 : _b.translatedText
                    });
                }
                else {
                    setStateLocal({
                        isGettingAudio: false,
                        isTranslating: false,
                        translatedText: ''
                    });
                }
            }
            else {
                console.error('No voice selected, just translate...');
                setStateLocal({
                    urlAudio: '',
                    isTranslating: true,
                    isGettingAudio: false
                });
                const translationResponse = yield api.translate({
                    text: state.selectedText,
                    sourceLanguage: 'en',
                    targetLanguage: state.languageCode
                });
                if (translationResponse === null || translationResponse === void 0 ? void 0 : translationResponse.translatedText) {
                    setStateLocal({
                        isTranslating: false,
                        translatedText: translationResponse === null || translationResponse === void 0 ? void 0 : translationResponse.translatedText
                    });
                }
                else {
                    setStateLocal({
                        isGettingAudio: false,
                        isTranslating: false,
                        translatedText: ''
                    });
                }
            }
        });
        if (state.selectedText && state.languageCode)
            perfomAction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedText, state.voiceId, state.languageCode]);
    useEffect(() => {
        if (audioRef.current && state.urlAudio) {
            audioRef.current.playbackRate = state.playbackRate;
        }
    }, [state.urlAudio, state.playbackRate]);
    useEffect(() => {
        setPosition({ x: 0, y: 0 });
    }, [state.currentScreen, state.miniPlayer]);
    const voiceListFiltered = state.voiceList.filter(voice => {
        return (voice.LanguageCode.startsWith(state.languageCode) ||
            (voice.AdditionalLanguageCodes && voice.AdditionalLanguageCodes.includes(state.languageCode)));
    });
    const currentVoice = state.voiceList.find(voice => voice.Id === state.voiceId);
    console.log('voiceListFiltered', voiceListFiltered);
    console.log('currentVoice', currentVoice);
    return (React.createElement(React.Fragment, null, state.currentScreen === 'player' && (React.createElement(Draggable, { handle: ".tsplayer-player-header", position: position, onStop: (e, data) => setPosition({ x: data.x, y: data.y }) },
        React.createElement("div", { style: {
                position: 'fixed',
                bottom: 10,
                right: 10,
                transform: 'translate(-50%, -50%)',
                width: 532,
                maxWidth: '90%',
                backgroundColor: 'white',
                boxShadow: 'rgba(0, 0, 0, 0.08) 0px 0px 14px 14px',
                zIndex: 1000,
                borderRadius: 24,
                maxHeight: '90vh'
            } },
            React.createElement("div", { className: classNames('tsplayer-content', {
                    'tsplayer-content-mini': state.miniPlayer
                }) },
                React.createElement("div", { className: classNames('tsplayer-player-header', {
                        'header-mini': state.miniPlayer
                    }) },
                    voiceListFiltered.length > 0 ? (React.createElement("div", { className: "tsplayer-title" }, (currentVoice === null || currentVoice === void 0 ? void 0 : currentVoice.CustomName) || (currentVoice === null || currentVoice === void 0 ? void 0 : currentVoice.Name) || 'Voice Buddy')) : (React.createElement("div", { className: "tsplayer-title" }, "Choose Your Language")),
                    React.createElement("div", { className: classNames('tsplayer-player-header-btns', {
                            'tsplayer-btns-mini': state.miniPlayer
                        }) },
                        state.miniPlayer ? (React.createElement("button", { onClick: () => setStateLocal({ miniPlayer: false }), className: "tsplayer-icon-button" },
                            React.createElement(MaxIcon, null))) : (React.createElement("button", { onClick: () => setStateLocal({ miniPlayer: true }), className: "tsplayer-icon-button" },
                            React.createElement(MinimizeIcon, null))),
                        React.createElement("button", { onClick: onClose, className: "tsplayer-icon-button" },
                            React.createElement(CloseIcon, null)))),
                React.createElement(BodyWidget, { voiceListFiltered: voiceListFiltered }),
                voiceListFiltered.length > 0 && (React.createElement("div", { className: "tsplayer-player-player" },
                    React.createElement(AudioPlayer, { volume: 1, src: state.urlAudio, onError: () => {
                            console.error('play error');
                        }, autoPlayAfterSrcChange: true, autoPlay: true, onPlay: () => setStateLocal({ isPlaying: true }), onPause: () => setStateLocal({ isPlaying: false }), onEnded: () => setStateLocal({ isPlaying: false }), ref: player => {
                            if (player)
                                audioRef.current = player.audio.current;
                        }, 
                        // layout="horizontal"
                        customAdditionalControls: [
                            RHAP_UI.LOOP,
                            React.createElement(SpeedButton, { playbackRate: 0.5, key: 'speed_btn_0.5' }),
                            React.createElement(SpeedButton, { playbackRate: 1, key: 'speed_btn_1' }),
                            React.createElement(SpeedButton, { playbackRate: 1.5, key: 'speed_btn_2.5' }),
                            React.createElement(SpeedButton, { playbackRate: 2, key: 'speed_btn_2' })
                        ] }))),
                !(state === null || state === void 0 ? void 0 : state.miniPlayer) && (React.createElement("div", { className: "tsplayer-player-options" },
                    React.createElement("div", { className: "tsplayer-player-options-item" },
                        React.createElement("label", { htmlFor: "language" }, "Language:"),
                        React.createElement("select", { value: state.languageCode, onChange: value => setStateLocal({
                                languageCode: value.target.value,
                                voiceId: ''
                            }) }, state.languageList.map(lang => (React.createElement("option", { value: lang.LanguageCode, key: lang.LanguageCode }, lang.LanguageName))))),
                    React.createElement("div", { className: "tsplayer-player-options-item" },
                        React.createElement("label", { htmlFor: "voiceId" }, "Voice Type:"),
                        voiceListFiltered.length === 0 ? (React.createElement("select", { value: state.voiceId, onChange: value => setStateLocal({ voiceId: value.target.value }), disabled: true },
                            React.createElement("option", { value: "" }, "No voice available"))) : (React.createElement("select", { value: state.voiceId, onChange: value => setStateLocal({ voiceId: value.target.value }) },
                            React.createElement("option", { value: "" }, "Choose a voice"),
                            voiceListFiltered.map(voice => (React.createElement("option", { value: voice === null || voice === void 0 ? void 0 : voice.Id, key: voice === null || voice === void 0 ? void 0 : voice.Id },
                                (voice === null || voice === void 0 ? void 0 : voice.CustomName) || (voice === null || voice === void 0 ? void 0 : voice.Name),
                                " - ", voice === null || voice === void 0 ? void 0 :
                                voice.Gender,
                                " - ", voice === null || voice === void 0 ? void 0 :
                                voice.LanguageName))))))))))))));
};
export default TSPlayer;
